import ENDPOINTS from "@/app/constants/api/api"
import { apiGet, apiPost } from "@/lib/api"
import type {
	ComparisonApiMessageResponse,
	ComparisonCommitParams,
	ComparisonExchangesParams,
	ComparisonHistoryResponse,
	ComparisonHistoryParams,
	ComparisonOrderResponseItem,
	ComparisonOrderPayload,
	ComparisonSideReferenceParams,
	ComparisonSideReferencePrice,
} from "@/app/components/Comparison/types/comparison.interface"
import type { ExchangeInterface } from "@/app/components/Comparison/types/exchangeTable.interface"

export const getComparisonExchanges = async (params: ComparisonExchangesParams, signal?: AbortSignal) => {
	return apiGet<ComparisonApiMessageResponse<ExchangeInterface[]>>(ENDPOINTS.COMPARISON_EXCHANGES, params, { signal })
}

export const getComparisonSideReferencePrice = async (params: ComparisonSideReferenceParams, signal?: AbortSignal) => {
	return apiGet<ComparisonApiMessageResponse<ComparisonSideReferencePrice>>(ENDPOINTS.COMPARISON_EXCHANGES, params, { signal })
}

export const getComparisonCommit = async (params: ComparisonCommitParams) => {
	return apiGet<ComparisonApiMessageResponse<ExchangeInterface>>(ENDPOINTS.COMPARISON_COMMIT, params)
}

export const getComparisonHistory = async (params: ComparisonHistoryParams) => {
	return apiGet<ComparisonApiMessageResponse<ComparisonHistoryResponse>>(ENDPOINTS.COMPARISON_HISTORY, params)
}

export const postComparisonOrder = async (payload: ComparisonOrderPayload) => {
	return apiPost<ComparisonApiMessageResponse<ComparisonOrderResponseItem>>(ENDPOINTS.COMPARISON_ORDER, {
		track_id: payload.track_id,
	})
}

export const getComparisonAltPrice = (symbol: string) =>
	apiGet<ComparisonApiMessageResponse<{ price?: number }>>(ENDPOINTS.ALT_PRICE, { symbol })
